/**
 * usePushNotifications — solicita permiso y suscribe al usuario a Web Push.
 * Se activa una vez cuando el usuario inicia sesión.
 */
import { useEffect } from 'react';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

async function getVapidKey() {
  const res = await fetch(`${BASE_URL}/push/vapid-public-key`);
  const data = await res.json();
  return data.publicKey;
}

async function suscribir(token) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  // Pedir permiso
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') return;

  const reg = await navigator.serviceWorker.ready;
  const vapidKey = await getVapidKey();
  if (!vapidKey) return;

  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
  }

  // Enviar suscripción al backend
  await fetch(`${BASE_URL}/push/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(subscription.toJSON()),
  });
}

export function usePushNotifications(usuario, token) {
  useEffect(() => {
    if (!usuario || !token) return;
    suscribir(token).catch((err) => {
      console.warn('[Push] Error al suscribir:', err.message);
    });
  }, [usuario?.id]); // eslint-disable-line
}

export default usePushNotifications;
